module.exports = __webpack_public_path__ + "img/idoom_logo.5a394f63.png";